import { useAtom } from 'jotai';
import { selectedOrganizationAtom } from '../state/selectedOrganization';

export function useHeurekaUpdateGrantsRedirect() {
  const [selectedPractice] = useAtom(selectedOrganizationAtom);
  return () => {
    window.location.href = `/api/suite/heureka/practices/${selectedPractice.id}/update-grants?redirectUri=${window.location.href}`;
  };
}
